import { DaymapQuery as s } from "../daymapQuery.js";
var f;
((t) => {
  class o extends s {
    constructor() {
      super(
        ["CurrentUser"],
        null,
        "/lms/api/contact/user",
        null
      );
    }
  }
  t.currentUser = o;
  class m extends s {
    constructor() {
      super(
        ["studentsForContact"],
        null,
        "/lms/api/contact/studentsforcontact",
        null
      );
    }
  }
  t.studentsForContact = m;
  class I extends s {
    constructor(e) {
      super(
        ["contactAvatar", e.contactId, e.studentId, e.staffId],
        e,
        `/lms/api/contact/image/${e.studentId ? `student/${e.studentId}` : e.staffId ? `staff/${e.staffId}` : e.contactId}`,
        { asBlob: !0 },
        { stale: 1 / 0, retry: 0 }
      );
    }
  }
  t.contactImage = I, ((a) => {
    class e extends s {
      constructor(n) {
        super(
          ["profilesetting", n.settingName],
          n,
          `/lms/api/contact/profilesetting/${n.settingName}`,
          { asText: n.asText },
          { stale: 1e3 * 60 * 5 }
        );
      }
    }
    a.Get = e;
    function c(i) {
      const n = {}, l = i.split("|");
      let d = l.length - 1;
      if (d % 2 === 0 && (d -= 1), d > 0)
        for (let r = 0; r <= d; r += 2) {
          const u = parseInt(l[r], 10), R = l[r + 1];
          isNaN(u) || (n[u] = R);
        }
      return n;
    }
    a.deserialiseIntKey = c;
  })(t.profilesetting || (t.profilesetting = {}));
  class x extends s {
    constructor(e) {
      const c = (e == null ? void 0 : e.contactId) ?? 0;
      super(
        ["getContact", c],
        { contactId: c },
        `/lms/api/contact?contactId=${c}`,
        { stale: 1e3 * 60 * 5 }
      );
    }
  }
  t.getContact = x;
  class h extends s {
    constructor(e) {
      super(
        ["searchRecipients", e.prefix],
        e,
        `/lms/api/contacts/search/recipients?prefix=${encodeURIComponent(e.prefix)}`,
        null,
        { stale: 1e3 * 60 * 5, enabled: !1 }
      );
    }
  }
  t.searchRecipients = h;
  class y extends s {
    constructor(e) {
      super(
        ["searchStaff", e.prefix, e.daymapId],
        e,
        `/lms/api/contacts/search/staff?prefix=${encodeURIComponent(e.prefix)}&daymapId=${e.daymapId}`,
        null,
        { stale: 1e3 * 60 * 5, enabled: !1 }
      );
    }
  }
  t.searchStaff = y;
  class C extends s {
    constructor(e) {
      super(
        ["searchStudents", e.prefix, e.daymapId],
        e,
        `/lms/api/contacts/search/students?prefix=${encodeURIComponent(e.prefix)}&daymapId=${e.daymapId}`,
        null,
        { stale: 1e3 * 60 * 5, enabled: !1 }
      );
    }
  }
  t.searchStudents = C;
  class $ extends s {
    constructor(e) {
      super(
        ["searchParents", e.prefix, e.daymapId],
        e,
        `/lms/api/contacts/search/parents?prefix=${encodeURIComponent(e.prefix)}&daymapId=${e.daymapId}`,
        null,
        { stale: 1e3 * 60 * 5, enabled: !1 }
      );
    }
  }
  t.searchParents = $;
  class g extends s {
    constructor(e) {
      super(
        ["searchContacts", e.prefix, e.daymapId],
        e,
        `/lms/api/contacts/search/contacts?prefix=${encodeURIComponent(e.prefix)}&daymapId=${e.daymapId}`,
        null,
        { stale: 1e3 * 60 * 5, enabled: !1 }
      );
    }
  }
  t.searchContacts = g;
})(f || (f = {}));
export {
  f as contact
};
//# sourceMappingURL=index.js.map
